import { z } from 'zod';
export const tableChangeEventSchema = z.object({
    table: z.string(),
});
//# sourceMappingURL=entity-changes.js.map